import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '../../services/shared.service';
import { FirebaseService } from '../../service/firebase.service';

@Component({
  selector: 'app-modal-main',
  templateUrl: './modal-main.component.html',
  styleUrls: ['./modal-main.component.scss']
})
export class ModalMainComponent implements OnInit {
  isValid: boolean = true;
  data: any;
  languageArray: any;




  constructor(public dialogRef: MatDialogRef<ModalMainComponent>,
    @Inject(MAT_DIALOG_DATA) public dataFromParent: any, public firebase: FirebaseService, public _sharedVar: SharedService) {
    // console.log("DATA:", data)
    this.languageArray = this._sharedVar.mediaLanguageArray.map((e: any) => { return { tag: e.tag } });
    // console.log(firebase.user)


   // console.log("THIS LANGUAGE ARRAY", this.languageArray)
    this.data = JSON.parse(JSON.stringify(dataFromParent))
   // console.log("DAT FROM PARENT:", this.data)

  //  console.log(this.data)
    if (this.data.complement == undefined)
      this.data.complement = [];

    if (this.data.winner == undefined)
      this.data.winner = true;

    if (this.data.index == 0)
      this.data.winner = false;

 //   console.log(this.data)

    if (this.data.elemType == 'folder') {
      if (!this.data.elemLang) {
        this.data.elemLang = this.languageArray;
      }
      else {
        this.languageArray.forEach((item: any) => {
          if (!this.data.elemLang.find(e => e.tag == item.tag))
            this.data.elemLang.push(item)
        })
      }
    }
  }

  canAccessSpecialPrize() {
    let uid = this.firebase.user.uid;
    let authorized = ['Xn9nWDRPeQdK4XhKEZH7Nvv5IIa2', 'u24R5wmGDPU9CVFlqq1aS6EaRQP2']

    if (authorized.includes(uid))
      return true;
    else
      return false
  }


  ngOnInit() {
    //console.log(this.data)

    console.log(this.data)

  }

  /**
   * Set local data
   * @param name data index
   * @param val new data value
   */
  setData(name, val) {
    this.data.item[name] = val;

    //console.log(this.data)
  }


  onChange(data) {
    this.data.eventFile = data.target.files[0];
  }
  /**
   * Set new fileEvent
   * @param data new fileEvent
   */
  onSlotImageChange(data) {
    //console.log(data);
    this.data.eventFile = data.target.files[0];

  }


  onEndImageChange(data) {
    this.data.endFile = data.target.files[0];
  }

  onEndSoundChange(data) {
    this.data.endSoundFile = data.target.files[0]


    console.log(this.data)
  }

  deleteFile(url, name) {
    if (url)
      this.firebase.deleteFileFromUrl(url)


    delete this.data[name]
  }

  /**
   * Set quantity's value
   * */
  setValue() {
    if (!this.data.winner)
      this.data.quantity = 0;
  }

  /**
   * Force the field to accept only numbers
   * @param event
   */
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  /**
   * Close modal
   * */
  onNoClick(): void {
    this.dialogRef.close();
  }

  /*
  * Manage Language
  */



}
